import {map} from 'lodash';

import Link from 'components/links/Link';
import DrugResultGridGenotypeResult from 'pages/genotypeResults/DrugResultGridGenotypeResult';

/**
 * A component that will display an annotation (usually based on a guideline annotation, label annotation, etc...) and
 * any genotype results (i.e., recommendations) that matched from that annotation.
 */
export default function DrugResultGridAnnotation({
  onOpenChange,
  recommendationAnnotations,
  genotypes,
  phenotypes,
  description,
  linkText,
  linkUrl,
  multipopulation,
  objCls,
  source,
}) {

  // this will add the GSI genotype to URL
  let url;
  if (linkUrl) {
    const searchParams = new URLSearchParams(window.location.search);
    url = `${linkUrl}?gsi=${searchParams.get('q')}`;
  }

  return (
    <div className="mb-2">
      <div>{description}</div>
      {map(recommendationAnnotations, (r) => (
        <DrugResultGridGenotypeResult
          key={`${r.id}`}
          phenotypes={phenotypes}
          genotypes={genotypes}
          onOpenChange={onOpenChange}
          multiPopulation={multipopulation}
          {...r}
          parentCls={objCls}
          parentSource={source}
        />
      ))}
      {linkText && url && <Link newTab={true} href={url}>{linkText}</Link>}
    </div>
  );
}
